import { render } from "./manage_customers_component.vue?vue&type=template&id=77c624e8&scoped=true"
import script from "./manage_customers_component.vue?vue&type=script&lang=js"
export * from "./manage_customers_component.vue?vue&type=script&lang=js"

import "./manage_customers_component.vue?vue&type=style&index=0&id=77c624e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c624e8"]])

export default __exports__